import { createFileRoute } from "@tanstack/react-router";

import { Tasks } from "@/features/settings/tasks/tasks";

export const Route = createFileRoute("/_authenticated/settings/tasks")({
  component: Tasks,
});
